module.exports = __webpack_public_path__ + "img/platinum-loyalty.bbb27f2.png";